import { useState } from 'react';
import { FileWithTimestamp } from '@features/components/ClinicalData/types';
import { LogItemLayout } from '@features/components/ClinicalData/components/ClinicalLog/components/LogItemLayout';
import { BaseEvent } from '@features/components/ClinicalData/components/ClinicalLog/components/BaseEvent';
import { Gallery } from '@features/components/ClinicalData/components/ClinicalLog/components/Gallery';
import { YesNoChip } from '../components/YesNoChip';

type WithAttachmentsItemProps = {
  shared?: boolean;
  event: string;
  mediaFiles?: FileWithTimestamp[];
  showGalleryNavigation?: boolean;
  description?: string;
  onShareClick?: () => void;
  yesNoValue?: boolean;
  customYesNoChipClassName?: string;
};

export const WithAttachmentsItem = ({
  shared,
  event,
  mediaFiles = [],
  showGalleryNavigation,
  description = '',
  onShareClick,
  yesNoValue,
  customYesNoChipClassName,
}: WithAttachmentsItemProps) => {
  const [selectedFileIndex, setSelectedFileIndex] = useState(0);

  return (
    <LogItemLayout>
      <div className="w-full flex flex-col gap-2">
        <BaseEvent
          onShareClick={onShareClick}
          event={event}
          shared={shared}
          description={description}
          endContent={<YesNoChip value={yesNoValue} className={customYesNoChipClassName} />}
        />
        <Gallery
          heading={event}
          showNavigation={showGalleryNavigation}
          mediaFiles={mediaFiles}
          selectedFileIndex={selectedFileIndex}
          setSelectedFileIndex={setSelectedFileIndex}
          onShareClick={onShareClick}
          isFromClinicalLog
        />
      </div>
    </LogItemLayout>
  );
};
